export const USER_TYPE_GET_REQUEST = 'USER_TYPE_GET_REQUEST';
export const USER_TYPE_GET_SUCCESS = 'USER_TYPE_GET_SUCCESS';
export const USER_TYPE_GET_ERROR = 'USER_TYPE_GET_ERROR';
export const USER_TYPE_GET_BY_KEY_REQUEST = 'USER_TYPE_GET_BY_KEY_REQUEST';
export const USER_TYPE_GET_BY_KEY_SUCCESS = 'USER_TYPE_GET_BY_KEY_SUCCESS';
export const USER_TYPE_GET_BY_KEY_ERROR = 'USER_TYPE_GET_BY_KEY_ERROR';
export const USER_TYPE_ADD_REQUEST = 'USER_TYPE_ADD_REQUEST';
export const USER_TYPE_ADD_SUCCESS = 'USER_TYPE_ADD_SUCCESS';
export const USER_TYPE_ADD_ERROR = 'USER_TYPE_ADD_ERROR';
export const USER_TYPE_EDIT_REQUEST = 'USER_TYPE_EDIT_REQUEST';
export const USER_TYPE_EDIT_SUCCESS = 'USER_TYPE_EDIT_SUCCESS';
export const USER_TYPE_EDIT_ERROR = 'USER_TYPE_EDIT_ERROR';
export const USER_TYPE_DELETE_REQUEST = 'USER_TYPE_DELETE_REQUEST';
export const USER_TYPE_DELETE_SUCCESS = 'USER_TYPE_DELETE_SUCCESS';
export const USER_TYPE_DELETE_ERROR = 'USER_TYPE_DELETE_ERROR';
